export type CookieValueTypes = string | boolean | undefined | null;
